module.exports = __webpack_public_path__ + "static/media/scl.45749471.jpeg";